<div style="text-align:center">
  <h1>You are not authorized to view the requested page</h1>
  <p>Please contact your administrator if you need access.</p>
  <br />
  <br />
  <button mat-raised-button color="primary" (click)="GoHome()">Home</button>
</div>
